import CartAPICall from "../service/CartAPICall";
import store from "../storeWire";
import ProductRepository from "./ProductRepository";
import { SET_CART_WEB_ORDER_ID, SET_CART_LOADER_DATA_OBJECT, SET_CART_DATA, SET_CLEAR_VALIDATE_CART, } from "../store/slice/model/Cart";
import { __set, __remove } from "../store/axios_indicator";
import { isArray } from "underscore";
import System from "../helper/system";
import ProductInventoryPriceRepository from "./ProductInventoryPriceRepository";
import Constants from "src/helper/Constants";
import Helper from "../helper/Helper";

const { storageName: { CART_ID, CART_PRODUCT_DATA } } = System
const { systemModules: { CART }, testCSSURL, devCSSURL } = Constants
class CartRepository {

    fetchCartCount = async (params) => {
        let res = await new CartAPICall().getCartCount(params);
        return res;
    };
    fetchCartData = async (params) => {
        let res = await new CartAPICall().getCartFromServer(params);
        let dataHere = res.data ? res.data : [];
        if (res?.data) {
            if (dataHere && dataHere.length) {
                dataHere = dataHere.map((v) => {
                    v.ERPPartNumber = v.partNumber;
                    v.ManufacturerPartNumber = v.manufacturerPartNumber;
                    v.ERPMFRPartNumber = v.erpMfrPartNumber;
                    v.ItemNumber = v.itemNumber;
                    v.CUSTOMER_PART_NUMBER = v.cpn;
                    if (v.isProductAvailableFromMainAPI === undefined) {
                        v.isProductAvailableFromMainAPI = true;
                    }
                    if (v.subtotal) {
                        v.subtotal = Math.round((v.subtotal + Number.EPSILON) * 100) / 100
                    }

                    if (v.quantity) {
                        let totalQuantity = 0;
                        let shipmentDetail = v.scheduleDetails;
                        if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
                            shipmentDetail.map((p, j) => {
                                totalQuantity = totalQuantity + p.quantity;
                            });
                            v.isScheduleTotalQtyValid = (totalQuantity > v.quantity) ? false : true
                        } else {
                            v.isScheduleTotalQtyValid = true
                        }
                    }
                    return v;
                })
            }
        } else {
            sessionStorage.removeItem(CART_ID)
        }
        if (res?.orderId) {
            this.setWebOrderID(res.orderId)
        }
        store.dispatch(SET_CART_DATA({
            CART_DATA: dataHere
        }))

        return res;
    };

    setWebOrderID = async (webOrderId) => {
        if (webOrderId) {
            store.dispatch(SET_CART_WEB_ORDER_ID({
                WEB_ORDER_ID: webOrderId
            }));
        }
    };

    fetchCartProducts = async () => {
        let state = store.getState();
        let cartDetail = state.entities?.Cart?.CART_DATA;
        if (cartDetail) {
            if (Object.entries(cartDetail)?.length) {
                let ItemNumbers = [];
                Object.entries(cartDetail).map((v) => {
                    ItemNumbers.push({ ItemNumber: v[1].ItemNumber, customerPartNumber: v[1].cpn });
                });
                if (ItemNumbers.length) {
                    let p = await new ProductRepository().getProductPriceInventoryAssets(ItemNumbers, { source: CART });
                    this.checkCartItemExistInProductList(p);

                    const allowed = ['ROHSCompliantCodeValue', 'ROHSCompliantCode', 'NCNRFlag', 'PackagingTypeCode', 'WebOnlyFlag', 'NPIFlag', 'ObsoleteFlag', 'TopSellerFlag', 'EndOfLifeFlag', 'ERPPartNumber', "isAvnetDistributor", "SoftwareDownloadFlag", "default_plant", "HazardousFlag", "Prop65Flag"];

                    let tempCopy = { ...p }
                    Object.keys(tempCopy).forEach((item, index) => {
                        let test = { ...tempCopy[item] }
                        Object.keys(test)
                            .filter(key => !allowed.includes(key))
                            .forEach(key => {
                                delete test[key]
                            })
                        tempCopy[item] = test
                    })
                    localStorage.setItem(CART_PRODUCT_DATA, JSON.stringify(tempCopy))
                    return p;
                }
            }
        }
    };

    checkCartItemExistInProductList(product) {
        let state = store.getState();
        if (state.entities?.Cart?.CART_DATA) {
            let cartDetail = JSON.parse(JSON.stringify(state.entities.Cart.CART_DATA));
            let productCartOutOfSync = false;
            let cart_list = [];
            if (Object.entries(cartDetail).length > 0) {
                Object.entries(cartDetail).map((v, i) => {
                    if (!product[v[1].ItemNumber]) {
                        v[1].isProductAvailableFromMainAPI = false;
                        cartDetail[v[1].ItemNumber] = v[1];
                        productCartOutOfSync = true;
                    }
                    cart_list.push(v[1])
                });

                if (productCartOutOfSync) {
                    store.dispatch(SET_CART_DATA({
                        CART_DATA: cart_list
                    }));
                }
            }
        }
    }

    replaceCartInBulk = async (params, fromBom = false) => {
        let server_response = await new CartAPICall().replaceCartInBulk(params);
        const ItemNumbers = params?.cartItems.map(obj => obj.ItemNumber)
        const result = server_response.data.cartItems.filter(item => ItemNumbers.includes(item.itemNumber))
        if (fromBom === true) {
            System.popup('AddedToCartBomPopup', { cartData: result, isCartBOM: true })
        } else {
            let response_data = {}
            response_data.data = result[0]
            if (server_response) {
                System.popup('AddedToCartNotification', { data: { server_response: response_data } })
            }
        }
    }

    // addToCartServer = async (params, isFrom, productData, isManuallyAddCart) => {
    //     store.dispatch(SET_CART_LOADER_DATA_OBJECT({}))
    //     let server_response = ''
    //     server_response = await new CartAPICall().addToCartServer(params);
    //     if (server_response) {
    //         // if (isManuallyAddCart) {
    //         //     __set('CART_API_CALL');
    //         //     await new CartRepository().initiatedKernelCall();
    //         //     __remove('CART_API_CALL');

    //         // } else {
    //             __set('CART_API_CALL');
    //             // await new CartRepository().fetchCartData({ minicart: true });

    //             let data = {
    //                 server_response,
    //                 params
    //             }
    //             let openAddedToCartNotification = true;
    //             if (data?.params?.dontOpenAddedToCartPopup || server_response?.data?.isBackOrderConfirmation === true) {
    //                 openAddedToCartNotification = false;
    //             }

    //             // if (server_response?.data?.isBackOrderConfirmation === true) {
    //             //     openAddedToCartNotification = false;
    //             //     System.popup('InventoryAlertForAddToCartPopup', { single_product: productData, addToCartParam: params, isFromManualCart: isManuallyAddCart })
    //             // }

    //             if (openAddedToCartNotification) {
    //                 System.popup('AddedToCartNotification', { data: data })
    //             }
    //             __remove('CART_API_CALL');
    //         // }
    //         if (server_response?.data?.isBackOrderConfirmation === true) {
    //             System.popup('InventoryAlertForAddToCartPopup', { single_product: productData, isFrom: isFrom, addToCartParam: params, isFromManualCart: isManuallyAddCart })
    //         }

    //         if (isManuallyAddCart && !server_response?.data?.isBackOrderConfirmation) {
    //             __set('CART_API_CALL');
    //             await new CartRepository().initiatedKernelCall();
    //             __remove('CART_API_CALL');
    //         }
    //     }
    //     return server_response;
    // };

    backorderNotAvailable = (single_product) => {
        if (single_product?.ObsoleteFlag || single_product?.EndOfLifeFlag || single_product?.specialPriceFlag || single_product?.constrainPartFlag || single_product?.isPartnerDistributor || single_product?.isNewarkDistributor || single_product?.ExcessInventoryFlag) {
            return true
        }
    }

    addToCartServer = async (params, isFrom, productData, isManuallyAddCart) => {
        store.dispatch(SET_CART_LOADER_DATA_OBJECT({}))
        let server_response = ''
        server_response = await new CartAPICall().addToCartServer(params);
        if (server_response) {
            __set('CART_API_CALL');
            let data = {
                server_response,
                params
            }
            if (server_response?.data?.isExists === true) {
                System.popup('CartItemReplacePopup', { product: productData, cartReplaceItem: params, isFrom: isFrom, isFromManualCart: isManuallyAddCart})
            }else if ((server_response?.data?.isBackOrderConfirmation === true && this.backorderNotAvailable(productData))) {
                System.popup('BackorderNotAvailable', { singleProduct: params })
            } else if (server_response?.data?.isBackOrderConfirmation === true) {
                System.popup('ProductBackorderedPopup', { product: productData, isFrom: isFrom, addToCartParam: params, isFromManualCart: isManuallyAddCart, cartRes: server_response?.data })
            } else {

                if (isManuallyAddCart) {
                    await new CartRepository().initiatedKernelCall();
                } else {

                    System.popup('AddedToCartNotification', { data: data })
                }
            }

            __remove('CART_API_CALL');
        }
        return server_response;
    };

    addCartInBulk = async (items) => {

        if (items && Object.entries((items).length > 0)) {
            let res = await new CartAPICall().addCartInBulk(items)

            const filteredItems = res.data.cartItems.filter(v =>
                items.cartItems.some(p => v.itemNumber === p.ItemNumber)
            ).map(v => {
                // Find the corresponding item in items.cartItems
                const matchedItem = items.cartItems.find(p => v.itemNumber === p.ItemNumber);
                // Add the ShortDescription to the object
                return { ...v, ShortDescription: matchedItem.ShortDescription };
            });

            return filteredItems
        }


        return false
    };

    updateToCartServer = async (params, fireUpdateEvent = true) => {
        __set('CART_OPERATION_API_CALL')
        let server_response = await new CartAPICall().updateToCartServer(params);
        if (server_response && fireUpdateEvent === true) {

            await new CartRepository().fetchCartData()
        }
        __remove('CART_OPERATION_API_CALL')
        return server_response;
    };

    clearAllCartFromServer = async () => {
        store.dispatch(SET_CART_DATA({
            CART_SUB_TOTAL: 0
        }))
        store.dispatch(SET_CLEAR_VALIDATE_CART({}))
        return await new CartAPICall().clearAllCartFromServer();
    };

    clearSingleCartProduct = async (params) => {
        store.dispatch(SET_CLEAR_VALIDATE_CART({}))
        let server_response = await new CartAPICall().clearSingleCartProduct(params.cartDetailId);
        if (server_response) {
            await new CartRepository().fetchCartData(params);
        }
        return server_response;
    };

    scheduleShippingApply = async (params) => {
        let server_response = await new CartAPICall().scheduleShippingApply(params);
        if (server_response) {
            __set('CART_API_CALL');
            await new CartRepository().fetchCartData({ minicart: true });
            __remove('CART_API_CALL');
        }
        return server_response;
    };

    updateBackOrderQuantityToCartServer = async (cartDetailItems) => {
        let server_response = await new CartAPICall().updateBackOrderQuantityToCartServer(cartDetailItems);
        if (server_response) {
            await new CartRepository().initiatedKernelCall();
        }
        return server_response;
    };


    checkItemExistsInCart = async (checkItemParam) => {
        return await new CartAPICall().checkItemExistsInCart(checkItemParam);
    };

    initiatedKernelCall = async (params = {}) => {
        await new CartRepository().fetchCartData(params);
        await new CartRepository().fetchCartProducts();
    };

    getDisplayStatusButton = (Product, Pricing, Inventory, type, extraParams) => {
        let inventory = new ProductInventoryPriceRepository().getInventoryByDistributor(Product, Inventory)
        if (type === 'cart') {
            if (!Product || Pricing?.length < 1) {
                return false
            } else {
                if (Product?.AllocationFlag || Product?.PIMBlock === 'E') {
                    return false
                } else if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                    return inventory > 0 ? true : false
                } else {
                    return true
                }
            }
        } else if (type === 'quoteLink') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1) ? false : true
            } else {
                return Product?.isAvnetDistributor ? true : false
            }
        } else if (type === 'quote') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1) ? false : true
            } else {
                if (Product?.AllocationFlag || Product?.PIMBlock === 'E' || Pricing?.length < 1 || Product?.QtyMin <= 0 || Product?.QtyMult <= 0) {
                    return true
                } else {
                    return false
                }
            }
        } else if (type === 'contactUs') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1)
            } else {
                return false
            }
        }

    }

    getValidateCartFromServer = async (params) => {
        return await new CartAPICall().getValidateCartFromServer(params);
    };

    fetchCartTax = async (params) => {
        return await new CartAPICall().fetchCartTax(params);
    };

    addComplianceData = async (params) => {
        return await new CartAPICall().addComplianceData(params);
    }
    getComplianceData = async (params) => {
        let data = []
        let complianceData = await new CartAPICall().getComplianceData(params);

        data = complianceData
        data?.questions?.forEach((item, index) => {

            if (item.questionType === 'RAD' && item.questionId === 134) {
                const obj = {
                    1: "Research, design and development of electronic components",
                    2: "Contract manufacturer of electronic components",
                    3: "Test of electronic components",
                    4: "Manufacturer of electronic components",
                    5: "Manufacturer of automobile components",
                    6: "Manufacturer of medical equipment",
                    7: "Distributor of electronic components",
                    8: "Not a corporation, purchased for individual use in personal electronic goods",
                    9: "University/Educational Facility"
                }
                item?.options.forEach((option, i) => {
                    item.fieldName = "company";
                    option.optionText = obj[option.optionOrder] ? obj[option.optionOrder] : "Other"
                })
            } else if (item.questionType === 'TXT' && item.questionId === 135) {
                item.fieldName = "other"
            } else if (item.questionType === 'RAD' && item.questionId === 136) {
                const obj = {
                    1: "Civil",
                    2: "Military",
                }
                item?.options.forEach((option, i) => {
                    item.fieldName = "typeOfProduct";
                    option.optionText = obj[option.optionOrder] ? obj[option.optionOrder] : "Governement"

                })
            } else if (item.questionType === 'RAD' && (item.questionId === 138 || item.questionId === 161)) {
                item?.options.forEach((option, i) => {
                    item.fieldName = item.questionId === 138 ? "exportProduct" : "freightForwarder"
                    if (option.optionOrder === 1) {
                        option.optionText = "Yes"
                    } else if (option.optionOrder === 2) {
                        option.optionText = "No"
                    }
                })
            } else if (item.questionType === 'RAD' && item.questionId === 170) {
                item?.options.forEach((option, i) => {
                    item.fieldName = "condition"
                    if (option.optionOrder === 1) {
                        option.optionText = "I Agree"
                    } else if (option.optionOrder === 2) {
                        option.optionText = "I Decline"
                    }
                })
                item.description = item.questionText
                item.questionText = "I certify the above facts are true and correct. I shall make prompt notification to Avnet of any change to the facts or intentions set forth above."
            }
        })

        return data
    }
    mergeGuestCartItems = async () => {
        return await new CartAPICall().mergeGuestCartItems();
    };

    getPaymentToken = async () => {
        const hostURL = Helper.getHostURL();
        const cssURL = hostURL.includes("test") ? testCSSURL : devCSSURL;
        return await new CartAPICall().getPaymentToken(hostURL, cssURL);
    }
}

export default CartRepository;